import {
  MealPlanDataType,
  MealPlanTableType,
  MealPlansInput,
} from "@/types/meal-plan";
import { apiSlice } from "@/redux/apiSlice";

export const MealPlans = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getMealPlans: builder.query<MealPlanTableType, MealPlansInput>({
        query: (searchCretiria) => ({
          url: `/meal_plans?org_id=${searchCretiria.org_id}&${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MealPlans", "Foods"],
      }),
      createMealPlans: builder.mutation<any, MealPlanDataType>({
        query: (mealdata) => ({
          url: `/meal_plans`,
          method: "POST",
          body: mealdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["MealPlans", "Foods"],
      }),
      updateMealPlans: builder.mutation<any, MealPlanDataType>({
        query: (mealdata) => ({
          url: `/meal_plans/${mealdata.id}`,
          method: "PUT",
          body: mealdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["MealPlans", "Foods"],
      }),
      deleteMealPlans: builder.mutation<
        any,
        {
          meal_plan_id: number;
          org_id: number;
        }
      >({
        query: (mealData) => ({
          url: `/meal_plans/${mealData.meal_plan_id}?org_id=${mealData.org_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["MealPlans", "Foods"],
      }),
      getMealPlanById: builder.query<MealPlanDataType, number>({
        query: (meal_plan_id) => ({
          url: `/meal_plans/${meal_plan_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MealPlans"],
      }),
      getMealPlansList: builder.query<{ id: number; name: string }[], number>({
        query: (org_id) => ({
          url: `/meal_plans/list/${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["MealPlans", "Foods"],
      }),
    };
  },
});

export const {
  useGetMealPlansQuery,
  useCreateMealPlansMutation,
  useUpdateMealPlansMutation,
  useDeleteMealPlansMutation,
  useGetMealPlanByIdQuery,
  useGetMealPlansListQuery,
} = MealPlans;
